import http from '@/components/services/http-common';
import formatter from '@/components/services/formatter';

export const get = (approvedByCode) => http.get('employeeReviews?', {
  params: {
    groupBy: 'employee',
    approvedByCode: approvedByCode
  }
}).then(res => {
  res.data.data= res.data.data.map(x => {
    // x.month1 = `${x?.month1?.score ?? 0} / ${x?.month1?.maxScore ?? 0}`
    // x.month2 = `${x?.month2?.score ?? 0} / ${x?.month2?.maxScore ?? 0}`
    // x.month3 = `${x?.month3?.score ?? 0} / ${x?.month3?.maxScore ?? 0}`
    // x.month4 = `${x?.month4?.score ?? 0} / ${x?.month4?.maxScore ?? 0}`
    // x.month5 = `${x?.month5?.score ?? 0} / ${x?.month5?.maxScore ?? 0}`
    // x.month6 = `${x?.month6?.score ?? 0} / ${x?.month6?.maxScore ?? 0}`
    // x.createdAt = formatter.formatDate(x.createdAt, "HH:mm DD/MM/YYYY")
    // x.validFrom = formatter.formatDate(x.validFrom)
    // x.validTo = formatter.formatDate(x.validTo)
    // x.status = x.status == 0 ? 'Tạo mới' : (x.status == 1 ? 'Hoàn tất' : 'Hủy')
    return x
  })
  return res.data
})

export const getDetail = (detailid) => {
  if(!detailid) {
    alert("NO ID")
    return
  }
  return http.get('employeeReviews/detail/'+detailid).then(res => res.data )
};

export const setScore = (reviewId, conditionId, score) => http.put(`employeeReviews/rate/${reviewId}/${conditionId}/${score}`);

export const submitScore = (reviewId) => http.post(`employeeReviews/rate/${reviewId}/submit`);